import { root } from './region';

export const region = {
  ...root,
};
